import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "order-list" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", {
  role: "separator",
  "aria-orientation": "horizontal",
  class: "v-divider",
  theme: "light"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", {
  role: "separator",
  "aria-orientation": "horizontal",
  class: "v-divider",
  theme: "light"
}, null, -1)

import FilterList from '@/components/FilterList.vue';
import Error from '@/components/Error.vue';
import Loading from '@/components/Loading.vue';
import Pagination from '@/components/Pagination.vue';
import WarehouseSelect from '@/components/WarehouseSelect.vue';
import InventoryListItem from '@/components/Inventory/InventoryListItem.vue';
import {RouteLocationRaw as RawLocation} from 'vue-router';
import router from '@/router';
import useInventoriesStore from '@/store/inventories';
import {useStorage} from '@/composables/storage';


export default /*#__PURE__*/_defineComponent({
  __name: 'InventoryList',
  setup(__props, { expose: __expose }) {

const store = useInventoriesStore();

useStorage(store);

function navigate(to: RawLocation) {
  router.push(to).catch(console.error);
}

__expose({
  FilterList,
  Error,
  Loading,
  Pagination,
  WarehouseSelect,
  InventoryListItem,
  store,
  navigate,
});

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, {
      class: "py-1 px-3 bg-grey-lighten-4",
      fluid: ""
    }, {
      default: _withCtx(() => [
        _createVNode(WarehouseSelect),
        (!_unref(store).loading && _unref(store).displayFilters.length > 0)
          ? (_openBlock(), _createBlock(FilterList, {
              key: 0,
              store: _unref(store)
            }, null, 8, ["store"]))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 1
    }),
    (!_unref(store).loading && !_unref(store).error)
      ? (_openBlock(), _createBlock(_component_v_list, {
          key: 0,
          lines: "two",
          class: "pa-0"
        }, {
          default: _withCtx(() => [
            (_unref(store).data)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(store).data, (inventory) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: inventory.BelegNr
                  }, [
                    _hoisted_2,
                    _createVNode(InventoryListItem, { inventory: inventory }, null, 8, ["inventory"]),
                    _hoisted_3
                  ], 64))
                }), 128))
              : _createCommentVNode("", true),
            _createVNode(_component_v_container, {
              fluid: "",
              class: "mb-10"
            }, {
              default: _withCtx(() => [
                _createVNode(Pagination, {
                  module: _unref(store).$id
                }, null, 8, ["module"])
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        }))
      : (_unref(store).error)
        ? (_openBlock(), _createBlock(_component_v_container, {
            key: 1,
            class: "py-1",
            fluid: ""
          }, {
            default: _withCtx(() => [
              _createVNode(Error, {
                module: _unref(store).$id
              }, null, 8, ["module"])
            ], undefined, true),
            _: 1
          }))
        : (_openBlock(), _createBlock(Loading, { key: 2 })),
    _createVNode(_component_v_btn, {
      icon: "",
      class: "ma-3",
      style: {"z-index":"1"},
      position: "fixed",
      location: "right bottom",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (navigate({ name: 'inventory_create' }))),
      color: "primary"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, null, {
          default: _withCtx(() => [
            _createTextVNode("mdi-plus")
          ], undefined, true),
          _: 1
        })
      ], undefined, true),
      _: 1
    })
  ]))
}
}

})